import { useLegend } from "src/hooks/useLegend";
import { ScaleItem } from "./ScaleItem";

interface Props {
  legendPath: string;
}

export function LegendFront(props: Props) {
  const { data: legend } = useLegend(props.legendPath);

  // render the component
  return render();

  function render() {
    if (!legend) return null;

    return (
      <div>
        {legend.colorMap.entries.map((item, i) => (
          <ScaleItem key={i} data={item}></ScaleItem>
        ))}
      </div>
    );
  }
}
